"use strict";
// Generated from ./src/lang/Scheme.g4 by ANTLR 4.9.0-SNAPSHOT
// @ts-ignore
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemeLexer = void 0;
const ATNDeserializer_1 = require("antlr4ts/atn/ATNDeserializer");
const LexerATNSimulator_1 = require("antlr4ts/atn/LexerATNSimulator");
const Lexer_1 = require("antlr4ts/Lexer");
const Utils = require("antlr4ts/misc/Utils");
const VocabularyImpl_1 = require("antlr4ts/VocabularyImpl");
class SchemeLexer extends Lexer_1.Lexer {
    // tslint:enable:no-trailing-whitespace
    constructor(input) {
        super(input);
        this._interp = new LexerATNSimulator_1.LexerATNSimulator(SchemeLexer._ATN, this);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return SchemeLexer.VOCABULARY;
    }
    // @Override
    get grammarFileName() {
        return 'Scheme.g4';
    }
    // @Override
    get ruleNames() {
        return SchemeLexer.ruleNames;
    }
    // @Override
    get serializedATN() {
        return SchemeLexer._serializedATN;
    }
    // @Override
    get channelNames() {
        return SchemeLexer.channelNames;
    }
    // @Override
    get modeNames() {
        return SchemeLexer.modeNames;
    }
    static get _ATN() {
        if (!SchemeLexer.__ATN) {
            SchemeLexer.__ATN = new ATNDeserializer_1.ATNDeserializer().deserialize(Utils.toCharArray(SchemeLexer._serializedATN));
        }
        return SchemeLexer.__ATN;
    }
}
exports.SchemeLexer = SchemeLexer;
SchemeLexer.T__0 = 1;
SchemeLexer.T__1 = 2;
SchemeLexer.T__2 = 3;
SchemeLexer.T__3 = 4;
SchemeLexer.T__4 = 5;
SchemeLexer.T__5 = 6;
SchemeLexer.T__6 = 7;
SchemeLexer.STRING = 8;
SchemeLexer.NUMBER = 9;
SchemeLexer.BOOL = 10;
SchemeLexer.IDENTIFIER = 11;
SchemeLexer.WHITESPACE = 12;
SchemeLexer.COMMENT = 13;
// tslint:disable:no-trailing-whitespace
SchemeLexer.channelNames = ['DEFAULT_TOKEN_CHANNEL', 'HIDDEN'];
// tslint:disable:no-trailing-whitespace
SchemeLexer.modeNames = ['DEFAULT_MODE'];
SchemeLexer.ruleNames = [
    'T__0',
    'T__1',
    'T__2',
    'T__3',
    'T__4',
    'T__5',
    'T__6',
    'STRING',
    'NUMBER',
    'BOOL',
    'IDENTIFIER',
    'WHITESPACE',
    'COMMENT',
    'LETTER',
    'DIGIT',
    'IDENTIFIER_INITIAL',
    'IDENTIFIER_SUBSEQUENT',
    'PECULIAR_IDENTIFIER'
];
SchemeLexer._LITERAL_NAMES = [
    undefined,
    "'''",
    "'`'",
    "','",
    "',@'",
    "'('",
    "')'",
    "'.'"
];
SchemeLexer._SYMBOLIC_NAMES = [
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    'STRING',
    'NUMBER',
    'BOOL',
    'IDENTIFIER',
    'WHITESPACE',
    'COMMENT'
];
SchemeLexer.VOCABULARY = new VocabularyImpl_1.VocabularyImpl(SchemeLexer._LITERAL_NAMES, SchemeLexer._SYMBOLIC_NAMES, []);
SchemeLexer._serializedATN = '\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x02\x0F\x85\b\x01' +
    '\x04\x02\t\x02\x04\x03\t\x03\x04\x04\t\x04\x04\x05\t\x05\x04\x06\t\x06' +
    '\x04\x07\t\x07\x04\b\t\b\x04\t\t\t\x04\n\t\n\x04\v\t\v\x04\f\t\f\x04\r' +
    '\t\r\x04\x0E\t\x0E\x04\x0F\t\x0F\x04\x10\t\x10\x04\x11\t\x11\x04\x12\t' +
    '\x12\x04\x13\t\x13\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03' +
    '\x05\x03\x05\x03\x05\x03\x06\x03\x06\x03\x07\x03\x07\x03\b\x03\b\x03\t' +
    '\x03\t\x03\t\x03\t\x07\t;\n\t\f\t\x0E\t>\v\t\x03\t\x03\t\x03\n\x05\nC' +
    '\n\n\x03\n\x06\nF\n\n\r\n\x0E\nG\x03\n\x03\n\x06\nL\n\n\r\n\x0E\nM\x05' +
    '\nP\n\n\x03\v\x03\v\x03\v\x03\v\x05\vV\n\v\x03\f\x03\f\x07\fZ\n\f\f\f' +
    '\x0E\f]\v\f\x03\f\x05\f`\n\f\x03\r\x06\rc\n\r\r\r\x0E\rd\x03\r\x03\r\x03' +
    '\x0E\x03\x0E\x07\x0Ek\n\x0E\f\x0E\x0E\x0En\v\x0E\x03\x0E\x03\x0E\x03\x0F' +
    '\x05\x0Fs\n\x0F\x03\x10\x03\x10\x03\x11\x03\x11\x05\x11y\n\x11\x03\x12' +
    '\x03\x12\x03\x12\x05\x12~\n\x12\x03\x13\x03\x13\x03\x13\x03\x13\x05\x13' +
    '\x84\n\x13\x02\x02\x02\x14\x03\x02\x03\x05\x02\x04\x07\x02\x05\t\x02\x06' +
    '\v\x02\x07\r\x02\b\x0F\x02\t\x11\x02\n\x13\x02\v\x15\x02\f\x17\x02\r\x19' +
    '\x02\x0E\x1B\x02\x0F\x1D\x02\x02\x1F\x02\x02!\x02\x02#\x02\x02%\x02\x02' +
    '\x03\x02\t\x04\x02$$^^\x04\x02--//\x05\x02\v\f\x0F\x0F""\x04\x02\f\f' +
    '\x0F\x0F\x04\x02C\\c|\n\x02##&(,,11<<>A`a\x80\x80\x05\x02--/0BB\x02\x8E' +
    '\x02\x03\x03\x02\x02\x02\x02\x05\x03\x02\x02\x02\x02\x07\x03\x02\x02\x02' +
    '\x02\t\x03\x02\x02\x02\x02\v\x03\x02\x02\x02\x02\r\x03\x02\x02\x02\x02' +
    '\x0F\x03\x02\x02\x02\x02\x11\x03\x02\x02\x02\x02\x13\x03\x02\x02\x02\x02' +
    '\x15\x03\x02\x02\x02\x02\x17\x03\x02\x02\x02\x02\x19\x03\x02\x02\x02\x02' +
    "\x1B\x03\x02\x02\x02\x03'\x03\x02\x02\x02\x05)\x03\x02\x02\x02\x07+\x03" +
    '\x02\x02\x02\t-\x03\x02\x02\x02\v0\x03\x02\x02\x02\r2\x03\x02\x02\x02' +
    '\x0F4\x03\x02\x02\x02\x116\x03\x02\x02\x02\x13B\x03\x02\x02\x02\x15U\x03' +
    '\x02\x02\x02\x17_\x03\x02\x02\x02\x19b\x03\x02\x02\x02\x1Bh\x03\x02\x02' +
    '\x02\x1Dr\x03\x02\x02\x02\x1Ft\x03\x02\x02\x02!x\x03\x02\x02\x02#}\x03' +
    "\x02\x02\x02%\x83\x03\x02\x02\x02'(\x07)\x02\x02(\x04\x03\x02\x02\x02" +
    ')*\x07b\x02\x02*\x06\x03\x02\x02\x02+,\x07.\x02\x02,\b\x03\x02\x02\x02' +
    '-.\x07.\x02\x02./\x07B\x02\x02/\n\x03\x02\x02\x0201\x07*\x02\x021\f\x03' +
    '\x02\x02\x0223\x07+\x02\x023\x0E\x03\x02\x02\x0245\x070\x02\x025\x10\x03' +
    '\x02\x02\x026<\x07$\x02\x0278\x07^\x02\x028;\v\x02\x02\x029;\n\x02\x02' +
    '\x02:7\x03\x02\x02\x02:9\x03\x02\x02\x02;>\x03\x02\x02\x02<:\x03\x02\x02' +
    '\x02<=\x03\x02\x02\x02=?\x03\x02\x02\x02><\x03\x02\x02\x02?@\x07$\x02' +
    '\x02@\x12\x03\x02\x02\x02AC\t\x03\x02\x02BA\x03\x02\x02\x02BC\x03\x02' +
    '\x02\x02CE\x03\x02\x02\x02DF\x05\x1F\x10\x02ED\x03\x02\x02\x02FG\x03\x02' +
    '\x02\x02GE\x03\x02\x02\x02GH\x03\x02\x02\x02HO\x03\x02\x02\x02IK\x070' +
    '\x02\x02JL\x05\x1F\x10\x02KJ\x03\x02\x02\x02LM\x03\x02\x02\x02MK\x03\x02' +
    '\x02\x02MN\x03\x02\x02\x02NP\x03\x02\x02\x02OI\x03\x02\x02\x02OP\x03\x02' +
    '\x02\x02P\x14\x03\x02\x02\x02QR\x07%\x02\x02RV\x07v\x02\x02ST\x07%\x02' +
    '\x02TV\x07h\x02\x02UQ\x03\x02\x02\x02US\x03\x02\x02\x02V\x16\x03\x02\x02' +
    '\x02W[\x05!\x11\x02XZ\x05#\x12\x02YX\x03\x02\x02\x02Z]\x03\x02\x02\x02' +
    '[Y\x03\x02\x02\x02[\\\x03\x02\x02\x02\\`\x03\x02\x02\x02][\x03\x02\x02' +
    '\x02^`\x05%\x13\x02_W\x03\x02\x02\x02_^\x03\x02\x02\x02`\x18\x03\x02\x02' +
    '\x02ac\t\x04\x02\x02ba\x03\x02\x02\x02cd\x03\x02\x02\x02db\x03\x02\x02' +
    '\x02de\x03\x02\x02\x02ef\x03\x02\x02\x02fg\b\r\x02\x02g\x1A\x03\x02\x02' +
    '\x02hl\x07=\x02\x02ik\n\x05\x02\x02ji\x03\x02\x02\x02kn\x03\x02\x02\x02' +
    'lj\x03\x02\x02\x02lm\x03\x02\x02\x02mo\x03\x02\x02\x02nl\x03\x02\x02\x02' +
    'op\b\x0E\x02\x02p\x1C\x03\x02\x02\x02qs\t\x06\x02\x02rq\x03\x02\x02\x02' +
    's\x1E\x03\x02\x02\x02tu\x042;\x02u \x03\x02\x02\x02vy\x05\x1D\x0F\x02' +
    'wy\t\x07\x02\x02xv\x03\x02\x02\x02xw\x03\x02\x02\x02y"\x03\x02\x02\x02' +
    'z~\x05!\x11\x02{~\x05\x1F\x10\x02|~\t\b\x02\x02}z\x03\x02\x02\x02}{\x03' +
    '\x02\x02\x02}|\x03\x02\x02\x02~$\x03\x02\x02\x02\x7F\x84\t\x03\x02\x02' +
    '\x80\x81\x070\x02\x02\x81\x82\x070\x02\x02\x82\x84\x070\x02\x02\x83\x7F' +
    '\x03\x02\x02\x02\x83\x80\x03\x02\x02\x02\x84&\x03\x02\x02\x02\x12\x02' +
    ':<BGMOU[_dlrx}\x83\x03\b\x02\x02';
//# sourceMappingURL=SchemeLexer.js.map